import isIE from 'services/isIE';
import arrayToGridLike from 'services/arrayToGridLike';

export const grids = (grid, settings: any = {}) => {
  const { numColumns = 3, children } = settings;

  const minWidth = Math.round(1100 / numColumns + 40);

  const uniformHeightBreakpoints = Array.from({ length: numColumns })
    .map((_, i) => i)
    .reverse()
    .reduce((acc, curr, i) => {
      return {
        ...acc,
        [`@media (max-width: ${minWidth * (curr + 1)}px)`]: {
          gridTemplateColumns: `repeat(${curr + 1}, 1fr)`,

          ...(isIE() && {
            // display: '-ms-grid',
            msGridColumns: `(1fr)[${curr + 1}]`,
          }),
        },
      };
    }, {});

  const getUniformHeightsLayout = () => {
    const cells = arrayToGridLike(children, numColumns);

    let gridCellCounter = -1;

    const uniformHeightsLayout = cells
      .map((row, rowIndex) => {
        return cells[rowIndex].reduce((acc, curr, index) => {
          const gridCell = `.grid-cell-${(gridCellCounter += 1)}`;

          return {
            ...acc,
            [gridCell]: {
              msGridColumn: index + 1,
              msGridRow: rowIndex + 1,
            },
          };
        }, {});
      })
      .reduce((acc, curr, index) => {
        return {
          ...acc,
          ...curr,
        };
      }, {});

    return { ...uniformHeightsLayout };
  };

  const getBannerColumnsLayout = () => {
    const newChildren = [...children];
    newChildren.splice(0, 1);

    const cells = arrayToGridLike(newChildren, numColumns);

    let gridCellCounter = 0;

    const bannerColumnsLayout = cells
      .map((row, rowIndex) => {
        return cells[rowIndex].reduce((acc, curr, index) => {
          const gridCell = `.grid-cell-${(gridCellCounter += 1)}`;

          return {
            ...acc,
            [gridCell]: {
              gridColumn: index + 1,
              gridRow: rowIndex + 2,

              msGridColumn: index + 1,
              msGridRow: rowIndex + 2,
            },
          };
        }, {});
      })
      .reduce((acc, curr, index) => {
        return {
          ...acc,
          ...curr,
        };
      }, {});

    return { ...bannerColumnsLayout };
  };

  return {
    uniformHeight: {
      display: 'grid',
      gridTemplateColumns: `repeat(${numColumns}, minmax(215px, 1fr))`,

      ...(isIE() && {
        display: '-ms-grid',
        msGridColumns: `(1fr)[${numColumns}]`,

        ...getUniformHeightsLayout(),
      }),

      ...uniformHeightBreakpoints,
    },
    '2/3HeroImage': {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridTemplateRows: `repeat(${children.length - 1})`,

      ...(isIE() && {
        display: '-ms-grid',
        msGridColumns: '1fr 1fr 1fr',
      }),

      width: '100%',

      '.grid-cell-0': {
        gridColumn: '1/3',
        gridRow: `1/${children.length}`,

        msGridColumnSpan: 2,
        msGridRowSpan: 2,
      },

      ...children.reduce((acc, curr, index) => {
        return {
          ...acc,
          [`.grid-cell-${index + 1}`]: {
            gridColumn: 3,
            gridRow: index + 1,

            msGridColumn: 3,
            msGridRow: index + 1,
          },
        };
      }, {}),

      '@media (max-width: 768px)': {
        display: 'block',
      },
    },
    bannerColumns: {
      display: 'grid',
      gridTemplateColumns: `repeat(${numColumns}, 1fr)`,
      // 3
      gridTemplateRows: `repeat(${(children.length - 1) / numColumns})`,
      // 3

      ...(isIE() && {
        display: '-ms-grid',
        msGridColumns: Array.from({ length: numColumns })
          .map((entry, index: number) => {
            return '1fr';
          })
          .join(' '),
      }),

      width: '100%',

      '.grid-cell-0': {
        gridColumn: `1/${numColumns + 1}`,
        gridRow: 1,
        msGridColumnSpan: numColumns,
        msGridRow: 1,
      },

      ...getBannerColumnsLayout(),

      '@media (max-width: 768px)': {
        display: 'block',
      },
    },
  }[grid];
};
